import { cdnCampaignsPath } from "@/constants/cdnUrls";
import { PATHS } from "@/constants/pathnames";
import { getLocalizedPath } from "@/utils/pathUtils";
import clsx from "clsx";
import Image from "next/image";
import React from "react";

function CampaignTabs({ t, pageType }) {
  const tabs = [
    {
      key: "allCampaigns",
      label: t("campaigns.allTabTitle"),
      href: "/campaigns",
      icon: cdnCampaignsPath + "coupon.svg",
    },
    {
      key: "flight",
      label: t("campaigns.flightTabTitle"),
      href: getLocalizedPath(PATHS.CAMPAGINS_FLIGHT.PATH),
      icon: cdnCampaignsPath + "flight-tab-icon.svg",
    },
    {
      key: "hotel",
      label: t("campaigns.hotelTabTitle"),
      href: getLocalizedPath(PATHS.CAMPAGINS_HOTEL.PATH),
      icon: cdnCampaignsPath + "hotel-tab-icon.svg",
    },
    {
      key: "bus",
      label: t("campaigns.busTabTitle"),
      href: getLocalizedPath(PATHS.CAMPAGINS_BUS.PATH),
      icon: cdnCampaignsPath + "bus-tab-icon.svg",
    },
    {
      key: "car",
      label: t("campaigns.carTabTitle"),
      href: getLocalizedPath(PATHS.CAMPAGINS_CAR.PATH),
      icon: cdnCampaignsPath + "car-tab-icon.svg",
    },
    {
      key: "ferry",
      label: t("campaigns.ferryTabTitle"),
      href: getLocalizedPath(PATHS.CAMPAGINS_FERRY.PATH),
      icon: cdnCampaignsPath + "ferry-tab-icon.svg",
    },
  ];

  return (
    <div className="relative">
      {/* Scrollable tab row */}
      <div className="scrollbar-hide mr-[-16px] flex gap-3 overflow-x-auto md:mr-0">
        {tabs.map((tab) => {
          const isActive = tab.key === pageType;

          return (
            <a
              key={tab.key}
              href={tab.href}
              className={clsx(
                "flex flex-1 items-center gap-2 rounded-lg bg-white py-4 pr-[10px] pl-[14px]",
                "border transition-colors",
                isActive ? "shadow-lg" : "border-transparent",
              )}
              style={
                isActive
                  ? { border: "1.5px solid rgba(1, 0, 127, 0.80)" }
                  : undefined
              }
            >
              {tab.icon && (
                <span
                  className={clsx(
                    "flex !h-10 !w-10 items-center justify-center",
                    isActive ? "text-primary" : "text-foreground-muted",
                  )}
                >
                  <Image
                    src={tab.icon}
                    alt={tab.label}
                    width={40}
                    height={40}
                  />
                </span>
              )}
              <span
                className={clsx(
                  "w-[100px] text-left text-sm/19",
                  isActive
                    ? "text-primary font-semibold"
                    : "text-primary-strong font-medium",
                )}
              >
                {tab.label}
              </span>
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default CampaignTabs;
